// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"1278cfc6","717":"4beb5c1e"}[chunkId] + ".chunk.js";
};